export const TerminalDepositModesEnum = {
  Octo: 'OctoPay',
  Cash: 'Cash',
  Ticket: 'Ticket'
}